import { getLogo } from "../api/contracts";
import { showToast } from '../utils/showToast';
import i18n from "../i18n/index.js";

export const fetchLogos = async (user) => {
    //console.log('Fetching logos for user:', user);
  try {
    let logos;
    if (user?.companyId) {
      logos = await getLogo({ id: user.companyId, idType: 'company' });
    } else if (user?.logisticCompanyId) {
      logos = await getLogo({ id: user.logisticCompanyId, idType: 'logisticCompany' });
    } else {
      showToast(i18n.t('No se encontró ID de empresa o empresa logística.'), false);
      return null;
    }

    if (logos?.error) {
      showToast(i18n.t('Error al obtener los logos.'), false);
      return null;
    }

    return logos;
  } catch (err) {
    console.error('Error al obtener los logos:', err);
    showToast(i18n.t('Error al obtener los logos.'), false);
    return null;
  }
};